var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1ed760;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spotify"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spotify-2",
    "data-name": "Spotify"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Spotify-3",
    "data-name": "Spotify",
    className: "cls-2",
    d: "M702.1,971.47c-24.05-14.69-53.86-18.11-88.6-10.16A5.68,5.68,0,1,0,616,972.39c31.76-7.26,58.71-4.3,80.13,8.79h0a5.69,5.69,0,0,0,5.92-9.72Z",
    transform: "translate(-554 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Spotify-4",
    "data-name": "Spotify",
    className: "cls-2",
    d: "M712.8,944.67c-28.15-17.29-69.33-22.17-102.47-12.12a7.12,7.12,0,0,0,4.13,13.61c29-8.8,66.39-4.44,90.9,10.64a7.13,7.13,0,0,0,9.78-2.35h0A7.11,7.11,0,0,0,712.8,944.67Z",
    transform: "translate(-554 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Spotify-5",
    "data-name": "Spotify",
    className: "cls-2",
    d: "M605.17,901.72l-.23.07a8.53,8.53,0,0,0,5.19,16.26c28.06-8.53,76.57-6.92,106,10.54h0a8.53,8.53,0,1,0,8.71-14.68C691,893.83,637.39,891.93,605.17,901.72Z",
    transform: "translate(-554 -831)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.09598e74ee8ac2b49c965f922a88b35e.svg";
export { ForwardRef as ReactComponent };